import React, { useState } from "react";
import { fireDB } from "../../firebase/FirebaseConfig";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { Card, Container, Form, Button } from "react-bootstrap";

const AddBlog = () => {
    const [title, setTitle] = useState("");
    const [thumbnail, setThumbnail] = useState("");
    const [shortDesc, setShortDesc] = useState("");
    const [content, setContent] = useState("");

    const handleAddBlog = async (e) => {
        e.preventDefault();
        try {
            await addDoc(collection(fireDB, "blogs"), {
                title,
                thumbnail,
                shortDesc,
                content,
                date: Timestamp.now(),
                author: "Admin",
            });

            alert("🎉 Blog Added Successfully!");

            setTitle("");
            setThumbnail("");
            setShortDesc("");
            setContent("");
        } catch (error) {
            console.log(error);
            alert("Failed to add blog");
        }
    };

    return (
        <Container className="my-5">
            <Card className="p-4 shadow-lg border-0 rounded-4">
                <h3 className="text-center mb-4 fw-bold">✍️ Add New Blog</h3>

                <Form onSubmit={handleAddBlog}>
                    {/* Blog Title */}
                    <Form.Group className="mb-3">
                        <Form.Label><strong>Blog Title</strong></Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter blog title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {/* Thumbnail */}
                    <Form.Group className="mb-3">
                        <Form.Label><strong>Thumbnail Image URL</strong></Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Paste thumbnail URL"
                            value={thumbnail}
                            onChange={(e) => setThumbnail(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {/* Short Description */}
                    <Form.Group className="mb-3">
                        <Form.Label><strong>Short Description</strong></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Enter a short intro"
                            value={shortDesc}
                            onChange={(e) => setShortDesc(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {/* Full Content */}
                    <Form.Group className="mb-3">
                        <Form.Label><strong>Full Blog Content</strong></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={7}
                            placeholder="Write complete blog content"
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {/* Submit Button */}
                    <div className="text-center">
                        <Button
                            type="submit"
                            className="px-4 py-2 rounded-pill"
                            variant="primary"
                        >
                            ➕ Add Blog
                        </Button>
                    </div>
                </Form>
            </Card>
        </Container>
    );
};

export default AddBlog;
